import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { SectionWrapper, SectionHeader } from '@/components/common';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title?: string;
  subtitle?: string;
  faqs?: FAQItem[];
  serviceType?: string;
  bgColor?: string;
  className?: string;
}

export function FAQSection({
  title,
  subtitle,
  faqs,
  serviceType,
  bgColor = 'bg-gray-50',
  className,
}: FAQSectionProps) {
  const { t } = useTranslation('services');

  // If faqs not provided, build from translations
  const displayFaqs = faqs || (serviceType ? [1, 2, 3, 4].map((num) => ({
    question: t(`${serviceType}.faq.q${num}`),
    answer: t(`${serviceType}.faq.a${num}`),
  })) : []);

  const displayTitle = title || (serviceType ? t(`${serviceType}.faq.title`) : '');
  const displaySubtitle = subtitle || (serviceType ? t(`${serviceType}.faq.subtitle`) : '');

  return (
    <SectionWrapper bgColor={bgColor} maxWidth="3xl" className={className}>
      <SectionHeader
        title={displayTitle}
        subtitle={displaySubtitle}
        className="mb-12"
      />

      <div className="space-y-4">
        {displayFaqs.map((faq, index) => (
          <details key={index} className="group bg-white rounded-xl shadow-sm">
            <summary className="flex items-center justify-between cursor-pointer p-6 text-left font-medium text-gray-900 hover:text-primary-600 transition-colors">
              {faq.question}
              <ArrowRight className="w-5 h-5 text-gray-400 group-open:rotate-90 transition-transform" />
            </summary>
            <div className="px-6 pb-6 text-gray-600">
              {faq.answer}
            </div>
          </details>
        ))}
      </div>
    </SectionWrapper>
  );
}
